import './initial';
import '../js/src/vendor/script/opacc.article.js';
import '../js/src/vendor/script/opacc.compare.js';
